module.exports = __webpack_public_path__ + "assets/img/IntelligentAnnouncement.72795d09.png";